import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalComponent } from 'ui-elements/modal';
import { ButtonLink, M2A, PromoModal } from 'www-cms';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-promo-modal',
  imports: [
    CommonModule,
    ModalComponent,
    ImageWithLoaderComponent,
    ButtonLinkComponent,
    DirectusDirective,
  ],
  templateUrl: './promo-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        --modal-mt: 0;
        --modal-mb: 0;
        --modal-close-mt: 0.75rem;
      }
    `,
  ],
})
export class PromoModalComponent {
  @Input({ required: true }) modalData!: PromoModal;

  buttons(index: number, item: M2A<ButtonLink>) {
    return item.item.id;
  }
}
